/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {getBranchList,getBranchListForDealer} from "@/api/Branch"

export default {
  addBranch({ commit }, branch) {
    return new Promise((resolve, reject) => {
      commit('ADD_BRANCH', branch)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsBranch({ commit },payload) {
   
    return new Promise((resolve, reject) => {
      getBranchList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_BRANCH', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
        
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  fetchDataListItemsBranchForDealer({ commit },payload) {
   
    return new Promise((resolve, reject) => {
      getBranchListForDealer(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_BRANCH', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
        
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateBranch({ commit }, branch) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_BRANCH', branch)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeBranch({ commit }, branchId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_BRANCH', branchId)
          resolve();
    })
  }
};
